var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"two"},[_c('div',{staticClass:"center"},[_c('img',{attrs:{"src":"https://gw-resources.uhan.net.cn/Official%20website/6.png","alt":""}})])])
}]

export { render, staticRenderFns }